<div dialog-header>
  <h4>Add New Lienholder</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>
<form [formGroup]="lienholderForm">
  <app-input-control formControlName="lienholderName" />
  <div class="new-lienholder-row address-row">
    <app-input-control formControlName="lienholderAddress1" label="Address 1" />
    <app-input-control formControlName="lienholderAddress2" label="Suite/Apt" />
  </div>
  <div class="new-lienholder-row">
    <app-input-control formControlName="lienholderPostalCode" (ngModelChange)="getPostalCode()" />
    <app-input-control formControlName="lienholderCity" [readOnly]="autoFill" />
  </div>
  <div class="new-lienholder-row">
    <app-input-control formControlName="lienholderCountryCode" [readOnly]="autoFill" />
    <app-input-control formControlName="lienholderStateProvince" [readOnly]="autoFill" />
  </div>
</form>
<div dialog-actions>
  <button ui-button (click)="addLienholder()" [disabled]="!lienholderForm.valid">Add</button>
  <button ui-button type="danger" (click)="close()">Cancel</button>
</div>
